import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import LogoDefault from 'assets/img/illustrations/falcon.png';

const Logo = ({ at = 'auth', width = 58, isAuthLayout = false, className, ...rest }) => {
  const settings = useSelector(state => state.settings);
  const { splash_logoISfile, title, logo_widthNUM } = settings;
  const logo = splash_logoISfile?.uri || LogoDefault;
  const authLogoWidth = '360px';
  const logoWidth = isAuthLayout ? authLogoWidth : logo_widthNUM || width;

  return (
    <Link
      to="/"
      className={classNames(
        'text-decoration-none',
        { 'navbar-brand text-left': at === 'navbar-vertical' },
        { 'navbar-brand text-left': at === 'navbar-top' }
      )}
      {...rest}
    >
      <div
        className={classNames(
          'd-flex',
          {
            'align-items-center py-3': at === 'navbar-vertical',
            'align-items-center': at === 'navbar-top',
            'flex-center fw-bolder fs-5 mb-4': at === 'auth'
          },
          className
        )}
      >
        <img src={logo} alt={title || 'Logo'} width={logoWidth} />
        {/* <span className={classNames('font-sans-serif', textClass)}>falcon</span> */}
      </div>
    </Link>
  );
};

Logo.propTypes = {
  at: PropTypes.oneOf(['navbar-vertical', 'navbar-top', 'auth']),
  width: PropTypes.number,
  className: PropTypes.string,
  textClass: PropTypes.string,
  isAuthLayout: PropTypes.bool
};

export default Logo;
